/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  Panel,
  Table,
} from 'react-bootstrap';
import RichLabel from 'loracoms/RichLabel';
import IntlMsg from 'lorautils/intl/IntlMsg';


const defaultProps = {
  reserved: [],
};
const propTypes = {
  channelPlan: React.PropTypes.object.isRequired,
  datarates: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  reserved: React.PropTypes.array,
};

class ChannelList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      channelPlan: this.props.channelPlan,
      reserved: this.props.reserved,
      datarates: this.props.datarates,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.banddetail.detailview');
  }

  componentWillReceiveProps(nextProps) {
    const { channelPlan, reserved, datarates } = nextProps;
    if (channelPlan !== this.props.channelPlan) {
      this.setState({ channelPlan });
    }
    if (reserved !== this.props.reserved) {
      this.setState({ reserved });
    }
    if (datarates !== this.props.datarates) {
      this.setState({ datarates });
    }
  }

  isReserved(channel) {
    const { reserved } = this.state;
    return _.some(reserved, rsrv => rsrv.id === channel.id);
  }

  reservedEnums() {
    return [{
      content: 'true',
      translate: this.intlMsg.msg('tabletd.reservedchannel'),
      theme: 'yellow',
    }, {
      content: 'false',
      translate: this.intlMsg.msg('tabletd.freechannel'),
      theme: 'blue',
    }];
  }

  render() {
    let channels = [];
    if (this.state.channelPlan.channels) {
      channels = this.state.channelPlan.channels;
    }

    const isDRInArr = (dr) => {
      const { datarates } = this.state;
      let hasDR = false;
      datarates.lora.forEach((item) => {
        if (item.dr === dr) {
          hasDR = true;
        }
      });
      return hasDR;
    };

    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg('panelhead.channellist')}>
        <Table className="aisz-table-light" striped hover bordered responsive>
          <thead>
            <tr>
              <th>{this.intlMsg.msg('tableth.channelid')}</th>
              <th>{this.intlMsg.msg('tableth.define')}</th>
              <th>{this.intlMsg.msg('tableth.type')}</th>
              <th>Frequence(MHZ)</th>
              <th>Min DR</th>
              <th>Max DR</th>
            </tr>
          </thead>
          <tbody>
            {_.sortBy(channels, 'id').map(item => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>
                  <RichLabel
                    content={String(this.isReserved(item))}
                    enums={this.reservedEnums()}
                  />
                </td>
                <td>{isDRInArr(item.mindr) ? 'LoRa' : 'FSK'}</td>
                <td>{item.freq / 1000000}</td>
                <td>{item.mindr}</td>
                <td>{item.maxdr}</td>
              </tr>
          ))}
          </tbody>
        </Table>
      </Panel>
    );
  }
}

ChannelList.defaultProps = defaultProps;
ChannelList.propTypes = propTypes;

export default injectIntl(ChannelList);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/ChannelPlanDetail/coms/ChannelList/index.jsx